module.exports = __webpack_public_path__ + "img/bg2.47c192cc.gif";